'use strict';

var _util = require('./util');

var _util2 = _interopRequireDefault(_util);

var _core = require('./core');

var _core2 = _interopRequireDefault(_core);

var _extension = require('./extension');

var _extension2 = _interopRequireDefault(_extension);

var _utilUrl = require('./util-url');

var _utilUrl2 = _interopRequireDefault(_utilUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @file DB
 * @date 2015-12-29
 * @depends Jquery|Zepto
 * option
 *     {
 *         url: '',
 *         type: 'get',
 *         data: {},
 *         cache: false,
 *         dataType: 'json',
 *         before: function(option) {return option;},
 *         succ: function(data, option) { return false; // 反转至err},
 *         err: function(data, option) {},
 *         'others' // 透传给Jquery|Zepto
 *     }
 * 全局配置
 *     DB.mergeOption(option)
 * 创建请求
 *     var db = new DB(option)
 * 发送请求
 *     db(option)
 *     DB.ajax(option)
 */
var defaultOption = {
  type: 'POST', // zepto不识别method
  dataType: 'json', // zepto 不识别JSON
  cache: false,
  /**
     * 获取错误码
     */
  getRetCode: function getRetCode(data) {
    var fields = ['ret', 'retcode', 'ret_code', 'ec', 'errCode', 'code'];

    var retcode = void 0;
    if (data) {
      Object.keys(fields).some(function (i) {
        var name = fields[i];
        if (!isNaN(data[name])) {
          retcode = data[name];
          return true;
        }
        return false;
      });
    }
    return retcode;
  }
};

// ie6下设置xhrFields会报错
if (!navigator.userAgent.match(/\bMSIE\s([\d.]+)/) || +RegExp.$1 > 8) {
  defaultOption.xhrFields = {
    withCredentials: true
  };
}

_core2.default.mergeOption(defaultOption);

/**
 * 添加全局插件
 * @param {String} name
 * @param {String} stage before|succ|err
 * @param {function} handle
 * @param {Object} handle.option 插件默认配置
 * 使用name + 'Enable'控制是否使用插件, 例如bknEnable:false将禁用bkn
 */
var addExtension = function addExtension(name, stage, handle) {
  var conf = {};
  var enableKey = handle.enableKey || name + 'Enable';
  conf[enableKey] = true;
  _util2.default.extend(conf, handle.option || {});
  conf[stage] = function () {
    if (this.option[enableKey]) {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return handle.call.apply(handle, [this].concat(args));
    }
  };
  _core2.default.mergeOption(conf);
};

addExtension('bkn', 'before', _extension2.default.before.bkn);

// 默认localEnable=false禁用状态
addExtension('local', 'before', _extension2.default.before.local);

addExtension('gtk', 'before', _extension2.default.before.gtk);

addExtension('platId', 'before', _extension2.default.before.platId);

addExtension('requestId', 'before', _extension2.default.before.requestId);

addExtension('params', 'before', _extension2.default.before.params);

// 在retCode之前因此err时也会被执行
addExtension('retCodeReport', 'succ', _extension2.default.succ.retCodeReport);

addExtension('retCode', 'succ', _extension2.default.succ.retCode);

addExtension('retCode', 'succ', _extension2.default.succ.networkError);

_core2.default.addExtension = addExtension;

_core2.default.utilUrl = _utilUrl2.default;

module.exports = _core2.default;